export const RETIREMENT_AGES_WHAT_IF_KEY = 0;
export const RETIREMENT_AGES_WHAT_IF_PATH = 'WhatIfRetirementAges';
